import { countUnread } from '../../utilities'

export const getNotifications = ({
  obj,
  you,
  convos,
  newChat,
  selected,
  wholeConvos
}) => {
  let notifs = 0

  Object.values(obj).forEach(val => {
    const { session, messages = [], notes = [], latest_activity = [] } = val

    const unread = wholeConvos[session]?.unread ?? 0

    // filtering out latest activity from message list to count
    let events = [...messages, ...notes]
    events = events.filter(ev => !latest_activity.find(la => la.id === ev.id))

    let currentCount = countUnread(session, convos, you, events)

    notifs += currentCount
    notifs += unread

    // currently including joins
    if (newChat.includes(session) && selected) {
      // adds closed at notifs
      notifs += 1

      // removes periodic adding notif in side nav when agent joins a convo
      if (!val.messages[0]?.type === 'join') {
        notifs += 1
      }

      // removes 1 notification if a join and msg were sent
      if (
        obj[session]?.isGroup &&
        !obj[session].latest_activity &&
        obj[session].messages.length &&
        obj[session]?.messages[messages.length - 1]?.type !== 'email'
      ) {
        notifs -= 1
      }
    }

    // dashboard - nothing has been selected yet
    if (newChat.includes(session) && !selected) {
      notifs += 1
      // removes 1 notification if a join and msg were sent
      if (
        obj[session]?.isGroup &&
        !obj[session].latest_activity &&
        obj[session].messages.length &&
        obj[session]?.messages[messages.length - 1]?.type !== 'email'
      ) {
        notifs -= 1
      }
    }
  })
  return notifs
}
